import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useLoaderData } from 'react-router-dom'
import { BookViewer } from '../components/book-viewer'
import { IBook } from '../types'
import { Header } from '../components/header'
import { WarningStrip } from '../components/warning-strip'
import { useAuth } from '../auth'


export const BookViewerPage: React.FC = () => {
  const book = useLoaderData() as IBook
  const { user } = useAuth()

  useEffect(() => {
    document.title = book.imprint_raw
  }, [book.imprint_raw])

  return (
    <Wrapper>
      <Header/>
      {
        !book.can_view_unblured_book && (
          <WarningStrip>
            Недостаточно прав для просмотра{!user && '. Попробуйте войти в систему'}
          </WarningStrip>
        )
      }
      <BookViewer book={book}/>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 100vh;
  background-color: rgb(249, 249, 252);
  display: flex;
  flex-direction: column;
`
